module.exports = __webpack_public_path__ + "static/img/Y2D30.c8aa429.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Y2D30.png
// module id = TKxa
// module chunks = 2